module.exports = __webpack_public_path__ + "static/media/1POLICY41.0f9a4c6d.jpg";